<template>
  <div>
    <policy-nav :chooseQy="chooseQy" :perfectInfo="perfectInfo" :report="report"></policy-nav>
    <div class="content def-container">
      <div class="input-group">
        <el-form :model="formData" label-position="left">
          <!-- <el-form-item prop="curShxydm" label="企业名称" label-width="150px" :rules="[{ required: true, message: '请输入企业名称', trigger: 'blur' }]">
            <el-select
              v-model="formData.curShxydm"
              filterable
              remote
              placeholder="请输入企业名称"
              :remote-method="getCompanyList"
              class="input-css"
              style="width: 100%"
              :loading="companyLoad"
              :disabled="userBaseInfo"
              @change="qymcChange"
            >
              <el-option
                v-for="item in companyList"
                :key="item.shxydm"
                :label="item.name"
                :value="item.shxydm"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item>
              <el-select
                v-model="formData.zcdz"
                clearable
                placeholder="请选择注册地址"
                :style="{ width: '100%' }"
              >
                <el-option label="信阳市" value="0"></el-option>
                <el-option label="省内其他地市" value="1"></el-option>
                <el-option label="省外" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select
                v-model="formData.qynsd"
                clearable
                placeholder="请选择纳税地"
                :style="{ width: '100%' }"
              >
                <el-option label="信阳市" value="0"></el-option>
                <el-option label="省内其他地市" value="1"></el-option>
                <el-option label="省外" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="formData.enterpriseRegisterType"
                clearable
                placeholder="注册类型"
                class="input-css"
                style="width: 100%"
              >
                <el-option
                  v-for="item in getDictList('enterprise_register_type')"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
        </el-form>
        <!-- <el-button class="button-css" @click="showDetail"
            >立即计算、看看能拿多少补贴</el-button
          > -->
      </div>
    </div>
    <!-- <div>
      <p class="h-title">历史计算</p>
      <el-row class="h-row">
        <el-col
          v-for="(item, index) in historySearch"
          v-bind:key="index"
          :span="8"
          style="cursor: pointer"
          @click.native.prevent="toresultpage(index)"
        >
          <div class="h-back">
            <div class="h-name">
              {{ item.name }}
            </div>
            <div class="h-delete" @click.prevent.stop="deleteHistory(index)">
              <i class="el-icon-delete"></i>
            </div>
          </div>
        </el-col>
      </el-row>
    </div> -->
    <!-- 详细查询 -->
    <div class="def-container" style="padding-bottom: 50px">
      <el-collapse v-model="collapseChoose" class="dt-collapse">
        <el-collapse-item name="1">
          <template v-slot:title>
            <div class="dt-title-icon"></div>
            <p class="dt-title">企业基本信息</p>
          </template>
          <el-form :model="formData" class="jjzbform" label-width="150px">
            <el-row>
              <el-col :span="12">
                <!-- <el-form-item label="企业名称">
                  <el-input v-model="formData.name" disabled></el-input>
                </el-form-item> -->
                <el-form-item
                  prop="curShxydm"
                  label="企业名称"
                  label-width="150px"
                  :rules="[
                    {
                      required: true,
                      message: '请输入企业名称',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    v-model="formData.curShxydm"
                    filterable
                    remote
                    placeholder="请输入企业名称"
                    :remote-method="getCompanyList"
                    class="input-css"
                    style="width: 100%"
                    :loading="companyLoad"
                    :disabled="userBaseInfo"
                    @change="qymcChange"
                  >
                    <el-option
                      v-for="item in companyList"
                      :key="item.shxydm"
                      :label="item.name"
                      :value="item.shxydm"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="注册时间">
                  <el-date-picker
                    v-model="formData.zcsj"
                    type="datetime"
                    placeholder="请输入注册时间"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="注册地">
                  <!-- <el-cascader
                    v-model="formData.zcdz"
                    :options="xzqh1Options"
                    :props="xzqh1Props"
                    :style="{ width: '100%' }"
                    placeholder="请选注册地址"
                    clearable
                  ></el-cascader> -->
                  <el-select
                    v-model="formData.zcdz"
                    clearable
                    placeholder="请选择注册地址"
                    :style="{ width: '100%' }"
                  >
                    <el-option label="信阳市" value="0"></el-option>
                    <el-option label="省内其他地市" value="1"></el-option>
                    <el-option label="省外" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="150px" label="纳税地" prop="xzqh1">
                  <!-- <el-cascader
                    v-model="formData.qynsd"
                    :options="xzqh1Options"
                    :props="xzqh1Props"
                    :style="{ width: '100%' }"
                    placeholder="请选择纳税地"
                    clearable
                  ></el-cascader> -->
                  <el-select
                    v-model="formData.qynsd"
                    clearable
                    placeholder="请选择纳税地"
                    :style="{ width: '100%' }"
                  >
                    <el-option label="信阳市" value="0"></el-option>
                    <el-option label="省内其他地市" value="1"></el-option>
                    <el-option label="省外" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 待修改 -->
              <el-col :span="12">
                <el-form-item label="所属行业">
                  <FormSelect
                    v-model="formData.gwjjfl"
                    size="small"
                    multiple
                    collapseTags
                    :options="getDictList('sys_category')"
                    valueKey="key"
                    style="width: 100%"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="产业类别">
                  <FormSelect
                    style="width: 100%"
                    v-model="formData.cylx"
                    multiple
                    collapseTags
                    size="small"
                    :options="getDictList('sys_enter_type')"
                    valueKey="key"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业注册类型">
                  <FormSelect
                    style="width: 100%"
                    v-model="formData.enterpriseRegisterType"
                    size="small"
                    :options="getDictList('enterprise_register_type')"
                    valueKey="key"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业资质">
                  <FormSelect
                    style="width: 100%"
                    v-model="formData.enterpriseQualification"
                    multiple
                    collapseTags
                    size="small"
                    :options="getDictList('enterprise_qualification')"
                    valueKey="key"
                  ></FormSelect>
                </el-form-item>
              </el-col>
               <el-col :span="12">
                <el-form-item label="统计关系所在地">
                  <el-select
                    style="width: 100%"
                    v-model="formData.tjgxszd"
                    placeholder="请选择统计关系所在地"
                  >
                    <el-option label="信阳市" value="0"></el-option>
                    <el-option label="省内其他地市" value="1"></el-option>
                    <el-option label="省外" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <el-form-item label="注册资本">
                  <el-input
                    v-model="formData.zczb"
                    placeholder="请输入注册资本(万)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="企业性质">
                  <FormSelect
                    v-model="formData.qyxz"
                    size="small"
                    :="false"
                    :options="getDictList('sys_regType')"
                    valueKey="key"
                    style="width: 100%"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="国民经济分类">
                  <FormSelect
                    v-model="formData.gwjjfl"
                    size="small"
                    :="false"
                    :options="getDictList('sys_category')"
                    valueKey="key"
                    style="width: 100%"
                  ></FormSelect>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="国民行业名称">
                  <FormSelect
                    v-model="formData.hymc"
                    size="small"
                    :="false"
                    :options="getDictList('sys_category')"
                    valueKey="key"
                    style="width: 100%"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="产业类型">
                  <FormSelect
                    v-model="formData.cylx"
                    size="small"
                    :="false"
                    :options="getDictList('sys_enter_type')"
                    style="width: 100%"
                    valueKey="key"
                  ></FormSelect>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="产业名称">
                  <FormSelect
                    v-model="formData.industrytype"
                    size="small"
                    :="false"
                    :options="tagList"
                    style="width: 100%"
                    valueKey="value"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册类型">
                  <FormSelect
                    v-model="formData.regtype"
                    size="small"
                    :="false"
                    :options="getDictList('sys_enterprise_registertype')"
                    style="width: 100%"
                    valueKey="key"
                  ></FormSelect>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="企业性质名称">
                  <FormSelect
                    v-model="formData.qyxzname"
                    size="small"
                    :="false"
                    :options="tagList"
                    style="width: 100%"
                    valueKey="value"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册机关">
                  <el-input
                    v-model="formData.zcjg"
                    placeholder="请输入注册机关"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label-width="150px"
                  label="统计关系所在地"
                  prop="xzqh1"
                >
                  <el-cascader
                    v-model="formData.tjgxszd"
                    :options="xzqh1Options"
                    :props="xzqh1Props"
                    :style="{ width: '100%' }"
                    placeholder="请选择统计关系所在地"
                    clearable
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row> -->
          </el-form>
          <div class="showMoreCon">
            <p class="showMore" @click="showMoreInfo">
              填写更多信息<i class="el-icon-caret-bottom"></i>
            </p>
            <p class="info">企业信息越完善，推荐越精确</p>
          </div>
        </el-collapse-item>
        <div v-show="showMoreInfoFlag">
          <el-collapse-item name="3">
            <template v-slot:title>
              <div class="dt-title-icon"></div>
              <p class="dt-title">企业经营信息</p>
            </template>
            <el-row :gutter="0">
              <el-tabs v-model="activeName">
                <el-tab-pane
                  v-for="(jjzb, index) in formData.jjzbList"
                  :key="index"
                  :label="nowYear - Number(index) - 1 + ''"
                  :name="nowYear - Number(index) - 1 + ''"
                >
                  <el-form
                    :ref="'elForm' + index"
                    :model="jjzb"
                    size="small"
                    label-width="144px"
                    class="jjzbform"
                  >
                    <el-col :span="12">
                      <el-form-item label="总资产" prop="zzc">
                        <el-input
                          type="number"
                          v-model="jjzb.zzc"
                          placeholder="请输入总资产"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="净利润" prop="jlr">
                        <el-input
                          type="number"
                          v-model="jjzb.jlr"
                          placeholder="请输入净利润"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="营业收入(万元)" prop="yysr">
                        <el-input
                          type="number"
                          v-model="jjzb.yysr"
                          placeholder="请输入营业收入(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="主营业务收入(万元)" prop="zyywsr">
                        <el-input
                          type="number"
                          v-model="jjzb.zyywsr"
                          placeholder="请输入主营业务收入(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="资产投入(万元)" prop="zctr">
                        <el-input
                          type="number"
                          v-model="jjzb.zctr"
                          placeholder="请输入资产投入(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="负债总额(万元)" prop="fzze">
                        <el-input
                          type="number"
                          v-model="jjzb.fzze"
                          placeholder="请输入负债总额(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="税收总额(万元)" prop="nsze">
                        <el-input
                          type="number"
                          v-model="jjzb.nsze"
                          placeholder="请输入税收总额(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="研发投入(万元)" prop="yftl">
                        <el-input
                          type="number"
                          v-model="jjzb.yftl"
                          placeholder="请输入研发投入"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="4">
            <template v-slot:title>
              <div class="dt-title-icon"></div>
              <p class="dt-title">知识产权</p>
            </template>
            <el-row :gutter="0">
              <el-form
                :model="formData.zscq"
                size="small"
                label-width="144px"
                class="jjzbform"
                ref="zscqForm"
              >
                <el-col :span="12">
                  <el-form-item label="知识产权总数" prop="zscqzs">
                    <el-input
                      type="number"
                      v-model="formData.zscq.zscqzs"
                      placeholder="请输入总资产"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="专利总数" prop="zlzs">
                    <el-input
                      type="number"
                      v-model="formData.zscq.zlzs"
                      placeholder="请输入专利总数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="注册商标总数" prop="zcsbzs">
                    <el-input
                      type="number"
                      v-model="formData.zscq.zcsbzs"
                      placeholder="请输入注册商标总数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="软件著作总数" prop="rjzzzs">
                    <el-input
                      type="number"
                      v-model="formData.zscq.rjzzzs"
                      placeholder="请输入软件著作总数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="5">
            <template v-slot:title>
              <div class="dt-title-icon"></div>
              <p class="dt-title">人才信息</p>
            </template>
            <el-row :gutter="0">
              <el-form
                :model="formData.rcxx"
                size="small"
                label-width="144px"
                class="jjzbform"
                ref="rcxxForm"
              >
                <el-col :span="12">
                  <el-form-item label="企业总人数" prop="qyzrs">
                    <el-input
                      type="number"
                      v-model="formData.rcxx.qyzrs"
                      placeholder="请输入企业总人数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="科技人数" prop="kjrs">
                    <el-input
                      type="number"
                      v-model="formData.rcxx.kjrs"
                      placeholder="请输入科技人数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="高级职称总人数" prop="gjzcrs">
                    <el-input
                      type="number"
                      v-model="formData.rcxx.gjzcrs"
                      placeholder="请输入高级职称总人数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="中级职称总人数" prop="zjzcrs">
                    <el-input
                      type="number"
                      v-model="formData.rcxx.zjzcrs"
                      placeholder="请输入中级职称总人数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </el-collapse-item>
        </div>
      </el-collapse>
      <el-divider></el-divider>
      <div class="dt-div-btn">
        <!-- <el-button class="dt-skip" @click="submit(1)">跳过</el-button> -->
        <el-button class="dt-confirm" @click="submit(2)"
          >获取智能推荐报告</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { FormSelect } from "@/components/form/index.js";
import policyNav from "./policyNav";
import { mapGetters } from "vuex";
const nowYear = Number(new Date().getFullYear());
export default {
  data() {
    return {
      chooseQy: "chooseQy",
      perfectInfo: "",
      report: "",
      showMoreInfoFlag: false,
      activeStep: 1,
      nowYear,
      activeName: nowYear - 1 + "",
      formData: {
        curShxydm: "",
        industry: "",
        money: "",
        scale: "",
        tjgxszd: "", //统计关系所在地（区划ID）
        qynsd: "", //企业纳税地
        gwjjfl: "", //'国民经济分类'
        hymc: "", //'国民行业名称'
        cylx: "", //产业类型
        industrytype: "", //产业名称
        qyxz: "", //企业性质（注册类型）',
        qyxzname: "", //'企业性质名称',
        regtype: "", //'注册类型(字典sys_enterprise_registertype)',
        name: "", //企业名称
        zcdz: "", //注册地址
        xzqhdm: "", //行政区划代码（注册地区划）
        xzqh3: "", // 行政区划-区（县）
        zcsj: "", // 注册时间
        enterpriseQualification: [], //   标签值
        enterpriseRegisterType: "", //企业注册类型
        ryName: "", // 荣誉资质名称
        // 知识产权
        zscq: {},
        // 人才信息
        rcxx: {},
        jjzbList: [],
      },
      historySearch: [],
      detailVisible: false, // 是否显示细节
      collapseChoose: ["1", "3", "4", "5"], // 选择
      companyList: [],
      tagList: [],
      value: "",
      companyLoad: false,
      newData: {
        yysr: "",
        zyywsr: "",
        xssr: "",
        jlr: "",
        jzc: "",
        zzc: "",
        ckze: "",
        jkze: "",
        fzze: "",
        ml: "",
        yftl: "",
        zdxmtz: "",
        nsze: "",
        qnsze: "",
        nszm: "",
        qysds: "",
        zzs: "",
        zrsds: "",
        qts: "",
        bz: "",
        createTime: "",
        updateTime: "",
        // webEid: '',
        year: "", // 年份
      },
      xzqh1Options: [],
      xzqh1Props: {
        multiple: false,
        label: "label",
        value: "value",
        children: "children",
        checkStrictly: true,
      },
      isCansubmit: false, //是否可提交
    };
  },
  components: {
    FormSelect,
    policyNav,
  },
  computed: {
    ...mapGetters({
      userBaseInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
    }),
  },
  created() {
    this.$store.dispatch("dictionary/commonSetDic", {
      types: [
        "sys_regType", // 企业性质
        "sq_policy_zjlx", // 扶持形式(资金)
        "sys_enter_type", // 产业类型()
        "sq_policy_xmlb", // 项目类别()
        "permit_sertype", // 办理对象()
        "sys_enterprise_registertype", // 注册类型()
        "sys_category", // 行业分类(国民经济分类)
        "enterprise_attributes", //企业属性
        "enterprise_size", //企业规模
        "growth_cycle", //成长周期
        "enterprise_qualification", //企业资质
        "enterprise_register_type",
      ],
    });
    this.getIndustryType();
    this.getqhdj();
    this.historySearch = JSON.parse(sessionStorage.getItem("historySearch"));
    if (this.$route.params.reopen) {
      this.detailVisible = true;
    }
    if (this.userBaseInfo) {
      this.formData.curShxydm = this.userBaseInfo.tyshxydm;
      this.formData.name = this.userBaseInfo.enterpriseInfo.enterprise;
      this.getCompanydetails();
    } else {
      if (this.historySearch.length > 0) {
        this.formData = this.historySearch[0];
      }
    }
    this.getCompanyList(this.formData.name);
  },
  watch: {
    "formData.jjzbList": {
      deep: true,
      handler: function (newVal) {
        if (newVal) {
          return newVal;
        }
      },
    },
  },
  methods: {
    qymcChange(val) {
      this.showDetail();
    },
    showMoreInfo() {
      if(this.formData.curShxydm==""){
        this.$message.warning("请先填写企业名称之后再完善信息！");
        return;
      }
      this.showMoreInfoFlag = !this.showMoreInfoFlag;
      if(this.showMoreInfoFlag){
        this.perfectInfo = "perfectInfo";
        this.chooseQy = "";
      }else {
        this.chooseQy = "chooseQy";
        this.perfectInfo = "";
      }
    },
    showDetail() {
      // if (
      //   this.formData.curShxydm == "" ||
      //   this.formData.enterpriseRegisterType == "" ||
      //   this.formData.zcdz == "" ||
      //   this.formData.qynsd == ""
      // ) {
      //   this.$message.warning("请填写完整表单");
      //   return;
      // }
      this.detailVisible = !this.detailVisible;
      // this.getCompanydetails();
      const newData = this.newData;
      let jjzbCreate = [newData, newData, newData];
      let case1 = nowYear - 1 + "";
      let case2 = nowYear - 2 + "";
      let case3 = nowYear - 3 + "";
      jjzbCreate = JSON.parse(JSON.stringify(jjzbCreate));
      jjzbCreate[0].year = case1;
      jjzbCreate[1].year = case2;
      jjzbCreate[2].year = case3;
      this.formData.jjzbList = jjzbCreate;
      this.companyList.forEach((item) => {
        if (item.shxydm == this.formData.curShxydm) {
          this.formData.name = item.name;
        }
      });
    },
    /**
     * 提交匹配数据
     * @param type
     *        1、跳过 详细企业信息查询
     *        2、包含 详细信息查询
     */
    submit(type) {
      sessionStorage.setItem("policySearchData", JSON.stringify(this.formData));
      let historySearch = JSON.parse(sessionStorage.getItem("historySearch"));
      if (historySearch == null) {
        historySearch = [];
      }
      if (historySearch.length > 0) {
        historySearch.forEach((item, i) => {
          if (item.curShxydm == this.formData.curShxydm) {
            historySearch.splice(i, 1);
          }
        });
      }
      historySearch.unshift(this.formData);

      sessionStorage.setItem("historySearch", JSON.stringify(historySearch));
      if (type == 1) {
        this.$router.push("/policyResult");
      } else if (type == 2) {
        this.report = "report";
        if(this.formData.curShxydm == ""){
          this.$message.warning("请填写企业名称之后再获取智能报告！");
          return;
        }
        if (this.userBaseInfo) {
          this.saveCompanyData();
        }
        this.$router.push("/policyResult");
      }
    },
    checkformData(form) {
      let state = false;
      let formName = {};
      if (Array.isArray(this.$refs[form])) {
        formName = this.$refs[form][0];
      } else {
        formName = this.$refs[form];
      }
      // 解决refs动态与静态
      formName.validate((valid) => {
        if (valid) {
          state = true;
        } else {
          state = false;
        }
      });
      return state;
    },
    toresultpage(index) {
      sessionStorage.setItem(
        "policySearchData",
        JSON.stringify(this.historySearch[index])
      );
      this.$router.push("/policyResult");
    },
    deleteHistory(index) {
      this.historySearch = this.historySearch.filter((item, i) => {
        return i != index;
      });
      sessionStorage.setItem(
        "historySearch",
        JSON.stringify(this.historySearch)
      );
    },
    getCompanyList(val) {
      this.companyLoad = true;
      let url = "/dev-api/enterprise/baseInfo/getListByName";
      let params = {
        name: val,
      };
      this.$httpApi
        .post(url, params)
        .then((r) => {
          this.companyLoad = false;
          if (r.code == 200) {
            this.companyList = r.data;
            // this.formData.cylx = [];
            // this.formData.enterpriseRegisterType = "";
            // this.formData.enterpriseQualification = [];
          } else {
            this.companyList = [];
          }
        })
        .catch((e) => {});
    },
    getIndustryType() {
      this.getClassWrap("sys_enter_type", "获取产业类型").then((res) => {
        console.log("产业类型", res);
        this.tagList = res;
      });
    },
    /**
     * 处理数据通用
     */
    async getClassWrap(el, title) {
      let endList = [];
      await this.getDictionaryInfo(el).then((res) => {
        if (res === 0) {
          console.log("字典暂无数据>>>");
        } else {
          // 处理数据
          // console.log(`${title || ''}处理前>>>`, res)
          const resList = JSON.parse(JSON.stringify(res.data));
          let target = [];
          for (const item of resList) {
            target.push({
              id: item.sort, // 0
              value: item.key, // "A"
              label: item.label, // "农、林..."
            });
          }
          // console.log(`获取${title || ''}处理后的数据>>>`, target)
          endList = target;
        }
      });
      return endList;
    },
    /**
     * 通用：根据字典类型获取字典信息
     */
    async getDictionaryInfo(el) {
      let response;
      await this.$httpApi
        .get("/dev-api/system/dict/getDictListByType", {
          dictType: el,
        })
        .then((res) => {
          // console.log("根据字典类型获取字典信息>>>", res)
          // console.log("--------------------------------------------")
          if (res.code == 200 && res.data.length !== 0) {
            response = res;
          } else {
            response = 0;
          }
        })
        .catch((err) => {});
      return response;
    },
    transformSA(el) {
      let target;
      if (Array.isArray(el)) {
        // 如果是数组
        target = el.toString();
      } else if (typeof el === "string") {
        //  如果是字符串
        target = el.split(",");
      } else {
        console.log("非法传参");
        target = [];
      }
      // console.log("最后输出值>>>", target)
      return target;
    },
    /**
     * 获取区划等级
     */
    getqhdj() {
      this.$httpApi
        .get("/dev-api/cfginfo/region/cascaderTreeList", {})
        .then((res) => {
          console.log("区划等级>>>", res);
          if (res.code == 200) {
            let resData = res.rows;
            resData.forEach((element) => {
              element.children.forEach((item) => {
                delete item.children;
              });
            });
            this.xzqh1Options = JSON.parse(JSON.stringify(resData));
          }
        })
        .catch((err) => {});
    },
    saveCompanyData() {
      let url = "/dev-api/enterprise/baseInfo/perfectEnterpriseInfo";
      let params = JSON.parse(JSON.stringify(this.formData));
      if (params.gwjjfl.length > 1) {
        params.gwjjfl = params.gwjjfl.join(",");
      } else {
        params.gwjjfl = params.gwjjfl.toString();
      }
      if (params.cylx.length > 1) {
        params.cylx = params.cylx.join(",");
      } else {
        params.cylx = params.cylx.toString();
      }
      if (params.enterpriseQualification.length > 1) {
        params.enterpriseQualification =
          params.enterpriseQualification.join(",");
      } else {
        params.enterpriseQualification =
          params.enterpriseQualification.toString();
      }
      this.$httpApi
        .post(url, params)
        .then((r) => {})
        .catch((e) => {});
    },
    getCompanydetails() {
      let url = "/dev-api/enterprise/baseInfo/getEnterpriseByShxydm";
      this.$httpApi
        .get(url, { shxydm: this.formData.curShxydm })
        .then((res) => {
          if (res.code === 200) {
            const _that = this;
            // let stringList = ["rzqd", "qyyd"];
            let target = JSON.parse(JSON.stringify(res.data));
            for (const [k, v] of Object.entries(target)) {
              if (v === "null") {
                target[k] = "";
              }
            }
            // 将字符串转成数字
            let numberList = [
              "zscqzs",
              "zlzs",
              "zcsbzs",
              "rjzzzs",
              "qyzrs",
              "kjrs",
              "gjzcrs",
              "zjzcrs",
              "cjzcrs",
              "gcjsryrs",
            ];
            Object.keys(target.zscq).forEach((key) => {
              if (numberList.indexOf(key) !== -1) {
                target.zscq[key] = Number(target.zscq[key]);
              }
            });
            Object.keys(target.rcxx).forEach((key) => {
              if (numberList.indexOf(key) !== -1) {
                target.rcxx[key] = Number(target.rcxx[key]);
              }
            });
            console.log("列表清洗后的数据>>>", target);
            this.$store.commit("updateAccountId", target.id);
            let cylx = _that.formData.cylx;
            let enterpriseRegisterType = _that.formData.enterpriseRegisterType;
            let enterpriseQualification =
              _that.formData.enterpriseQualification;
            _that.formData = Object.assign(_that.formData, target);
            const newData = this.newData;
            let jjzbCreate = [newData, newData, newData];
            let case1 = nowYear - 1 + "";
            let case2 = nowYear - 2 + "";
            let case3 = nowYear - 3 + "";
            jjzbCreate = JSON.parse(JSON.stringify(jjzbCreate));
            jjzbCreate[0].year = case1;
            jjzbCreate[1].year = case2;
            jjzbCreate[2].year = case3;
            if (target.jjzbList.length == 0) {
              this.formData.jjzbList = jjzbCreate;
            } else {
              for (const item of target.jjzbList) {
                switch (item.year) {
                  case case1:
                    jjzbCreate[0] = item;
                    break;
                  case case2:
                    jjzbCreate[1] = item;
                    break;
                  case case3:
                    jjzbCreate[2] = item;
                    break;
                }
                this.formData.jjzbList = jjzbCreate;
              }
            }
            if (cylx.length > 0) {
              this.formData.cylx = cylx;
            }
            if (enterpriseRegisterType) {
              this.formData.enterpriseRegisterType = enterpriseRegisterType;
            }
            if (enterpriseQualification.length > 0) {
              this.formData.enterpriseQualification = enterpriseQualification;
            }
          }
        })
        .catch((e) => {});
    },
  },
};
</script>
<style lang="scss"  scoped>
::v-ddep.el-tabs__item {
  font-size: 1rem;
}
/* ::v-ddep.el-tabs__nav-scroll {
  margin-left:6rem;
} */
::v-deep .el-step__icon.is-text {
  border: none !important;
}
::v-deep .el-step__icon {
  background: transparent !important;
}
::v-deep .el-step__line {
  background-color: #fff !important;
}
.banner {
  padding-top: 1vh;
  height: 200px;
  width: 99.1vw;
  background-repeat: no-repeat;
  background-size: 100vw 38.5vh;
 // background-image: url("~@/assets/images/js_banner.png");
  background-image: url("~@/assets/images/sub_banner.png");
  .stepCon {
    width: 900px;
    margin-left: calc(50% - 450px);
    margin-top: 60px;
    position: relative;
    .divider {
      width: 375px;
      height: 3px;
      background-color: #fff;
    }
    .step {
      font-size: 18px;
      color: #fff;
      position: absolute;
      top: 60px;
    }
    .step1 {
      left: -30px;
    }
    .step2 {
      left: 395px;
    }
    .step3 {
      width: 150px;
      left: 800px;
    }
    .num {
      display: inline-block;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      border: 1px solid #fff;
      text-align: center;
      line-height: 26px;
      color: #fff;
      margin-right: 6px;
    }
    .curStep {
      color: #fff71a;
      .num {
        color: #fff71a;
        border: 1px solid #fff71a;
      }
    }
  }
}
.content {
  margin-top: 20px;
}
.title {
  padding-top: 2vh;
  padding-left: 1.3vw;
  font-family: Microsoft YaHei;
  font-weight: 700;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
}
.input-group {
  // padding: 0vh 1.3vw 0 1.3vw;
}
.button-css {
  font-family: Microsoft YaHei;
  font-size: 1rem;
  margin-left: -0.1vw;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  width: 18.5vw;
  border-radius: 0px;
  //background-color: rgba(221, 0, 0, 1);
  background-color: rgba(221, 0, 0, 1);
}
.h-title {
  margin-left: 18vw;
  margin-top: 5vh;
  font-family: Microsoft YaHei;
  font-weight: 700;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
}
.h-row {
  width: 63vw;
  margin: 0 auto;
}
.h-back {
  margin-top: 1vh;
  height: 5.4vh;
  line-height: 5.4vh;
  margin-right: 0.5vw;
  padding-left: 1vw;
  background-color: rgba(249, 249, 249, 1);
}
.h-name {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  font-size: 1rem;
  float: left;
}
.h-delete {
  float: right;
  color: red;
  font-size: 2rem;
  margin-right: 1vw;
}
::v-ddep .el-input__inner {
  border-radius: 0px;
  height: 4vh;
}
/**  弹框  **/
::v-ddep .el-dialog__header {
  border-bottom: 1px solid rgba(232, 232, 232, 1);
}
::v-ddep .el-dialog__body {
  padding-top: 1vh;
}
::v-ddep .el-divider--horizontal {
  margin: 0;
}
.dt-top {
  font-family: Microsoft YaHei;
  font-weight: 700;
  font-size: 1.25rem;
  color: rgba(0, 0, 0, 1);
}
.dt-title-icon {
  height: 2.5vh;
 // border: 4px solid rgba(221, 0, 0, 1);
  border: 4px solid #1472FF;
}
.dt-title {
  margin-left: 1vw;
  font-family: Microsoft YaHei;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  font-size: 1.125rem;
}
.dt-collapse {
  border: none;
}
.showMoreCon {
  .showMore {
    cursor: pointer;
    text-align: center;
    font-size: 16px;
  //  color: #dd0000;
    color: #1472FF;
    font-weight: 600;
  }
  .info {
    text-align: center;
    font-size: 14px;
    color: #666;
  }
}
::v-ddep .el-collapse-item__wrap {
  border: none;
}
::v-ddep .el-collapse-item__header {
  border: none;
}
::v-ddep .dt-input-css .el-input__inner {
  border-radius: 0px;
  height: 3.7vh;
  width: 24vw;
}
::v-ddep .dt-input-css-four .el-input__inner {
  border-radius: 0px;
  height: 3.7vh;
  width: 12vw;
}
::v-ddep .dt-collapse .el-form-item {
  margin-bottom: 0;
}
::v-ddep .dt-collapse .el-form-item__label {
  line-height: 3vh;
  color: #000000;
}
::v-ddep .dt-collapse .el-collapse-item__content {
  margin-bottom: 0;
}
.dt-div-btn {
  text-align: center;
  margin-top: 2vh;
}
.dt-skip {
  border-color: rgba(221, 0, 0, 1);
  font-size: 18px;
  color: rgba(221, 0, 0, 1);
  width: 6vw;
}
.dt-confirm {
  //border-color: rgba(221, 0, 0, 1);
  border-color: #1472FF;
  font-size: 1.125rem;
 // background-color: rgba(221, 0, 0, 1);
  background-color: #1472FF;
  color: rgba(255, 255, 255, 1);
  width: 200px;
}
::v-ddep .el-button {
  border-radius: 0;
}
::v-deep .jjzbform > .el-row > .el-col {
  margin: 15px auto;
}
::v-deep .jjzbform > .el-row {
  margin: 15px auto;
}
::v-deep .jjzbform > .el-col {
  margin: 15px auto;
}

.icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #fff;
  background-color: #448DFC;
  background-position: center center;
  background-repeat: no-repeat;
}
.def-container{
  width: 1200px !important;
}
</style>
